<script setup lang="ts">
import { RouterLink } from 'vue-router'
</script>

<template>
  <header class="public-header">
    <RouterLink class="brand" to="/" aria-label="Message in a Bottle home">
      <span class="brand-mark" aria-hidden="true">✦</span>
      <span>Message in a Bottle</span>
    </RouterLink>
    <span class="header-tag">Read it · Carry it · Pass it on</span>
  </header>
</template>
